import { Gift } from 'lucide-react';
import { EmptyState } from '@mokoboko/components';

import {
  GiftCardTile,
  GiftCardTileSkeleton,
} from '@/components/gift-card-tile';
import useGiftCards from '@/state/gift-cards';
import useTenant from '@/state/tenant';

const LIST_CLASS = 'flex w-full flex-col gap-4 sm:gap-5';

export const GiftCards = ({
  // A section of the home page, but the whole of /gift-cards; only the caller
  // knows which, and on /gift-cards nothing else supplies the page's h1.
  headingAs: Heading = 'h2',
  showHeading = true,
}: {
  headingAs?: 'h1' | 'h2';
  showHeading?: boolean;
}) => {
  const { data: tenant } = useTenant();
  const { data: giftCards, isLoading } = useGiftCards();

  if (isLoading) {
    return (
      <div className={LIST_CLASS}>
        <GiftCardTileSkeleton />
        <GiftCardTileSkeleton />
        <GiftCardTileSkeleton />
      </div>
    );
  }

  if (!giftCards?.length) {
    return (
      <EmptyState
        icon={Gift}
        title="No gift cards found"
        description="Once gift cards are available, they will appear here"
        hasPattern
        className="pb-6"
      />
    );
  }

  return (
    <div className="flex w-full flex-col gap-4 sm:gap-5">
      {showHeading && (
        <div className="flex flex-col gap-1">
          <Heading className="heading-section">Gift cards</Heading>
          <p className="text-sm text-gray-700">
            A gift for someone you care about
          </p>
        </div>
      )}

      <div className={LIST_CLASS}>
        {giftCards.map((giftCard) => (
          <GiftCardTile
            key={giftCard.gift_card_id}
            giftCard={giftCard}
            studioName={tenant?.name ?? ''}
          />
        ))}
      </div>
    </div>
  );
};
